<script setup lang="ts">
import ArrowIcon from '~/assets/images/svg/btn-arrow.svg';

const partners = await queryContent('/partners').findOne()

const btnDetailsText = partners.btnDetailsText;
const btnWebsiteText = partners.btnWebsiteText;
</script>

<template>
  <section id="partners-section" class="partners">
    <div class="container">
      <h2 class="partners__title text-40">
        {{ partners.title }}
      </h2>
      <div class="partners__cards">
        <div
          v-for="(item, index) in partners.list"
          :key="index"
          class="partners__card-item partners-card"
        >
          <template v-if="item.logo && item.description">
            <NuxtImg
              class="partners-card__img"
              :src="item.background_image"
              loading="lazy"
              format="webp"
              alt="Фото"
            />
            <div class="partners-card__wrapper">
              <div class="partners-card__logo">
                <NuxtImg
                  :src="item.logo"
                  loading="lazy"
                  format="webp"
                  alt="Логотип"
                />
              </div>
              <div class="partners-card__text text-20">{{ item.description }}</div>
              <a :href="item.url" class="partners-card__btn" target="_blank">
                {{ btnDetailsText }}&nbsp;<span>{{ btnWebsiteText }}</span>
                <ArrowIcon class="partners-card__arrow-icon" />
              </a>
            </div>
          </template>
          <template v-else>
            <a :href="item.url" target="_blank" class="partners-card__link">
              <NuxtImg
                class="partners-card__img"
                :src="item.background_image"
                loading="lazy"
                format="webp"
                alt="Фото"
              />
            </a>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.partners {
  padding: 67px 0;

  @media (max-width: $large) {
    padding-top: 56px;
  }

  @media (max-width: $medium) {
    padding-top: 40px;
  }

  &__cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 30px;

    @media (max-width: $medium) {
      gap: 15px;
    }

    @media (max-width: $mobile) {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }

  &__title {
    margin-bottom: 56px;
    color: var(--dark-color);

    @media (max-width: $medium) {
      margin-bottom: 36px;
    }
  }
}

.partners-card {
  padding: 52px 52px 63px;
  border-radius: 30px;
  position: relative;
  display: block;

  @media (max-width: $large) {
    padding: 40px;
  }

  @media (max-width: $medium) {
    padding: 24px;
  }

  @media (max-width: $mobile) {
    padding: 16px;

    .partners-card__btn {
      span {
        display: none;
      }
    }
  }

  &:not(:first-child) {
    .partners-card__img {
      @media (max-width: $large) {
        height: 17%;
      }
    }

    @media (max-width: $medium) {
      .partners-card__img {
        display: none;
      }

      .partners-card__btn {
        span {
          display: none;
        }
      }
    }
  }

  &:nth-child(1) {
    background: linear-gradient(315deg, rgba(117, 204, 194, 0.3) 0%, rgba(116, 155, 255, 0.3) 50%, rgba(127, 116, 255, 0.3) 100%);
    display: flex;
    gap: 93px;
    grid-column: span 3;

    .partners-card__img {
      position: relative;
      display: block;
      margin: 0 auto;
      height: auto;
      max-width: 100%;
    }
  }

  &:nth-child(2) {
    background-color: var(--info-color);

    .partners-card__logo {
      height: 48px;

      @media (max-width: $mobile) {
        height: 40px;
      }
    }
  }

  &:nth-child(3) {
    background-color: var(--success-color);

    .partners-card__logo {
      height: 42px;

      @media (max-width: $mobile) {
        height: 40px;
      }
    }
  }

  &:nth-child(4) {
    background: linear-gradient(227.11deg, #7F74FF 0%, #749BFF 50.5%, #75CCC2 100%);

    .partners-card__logo {
      height: 48px;

      @media (max-width: $mobile) {
        height: 40px;
      }
    }
  }

  &__logo {
    margin-bottom: 44px;

    @media (max-width: $large) {
      margin-bottom: 36px;
    }

    @media (max-width: $medium) {
      margin-bottom: 32px;
    }

    @media (max-width: $mobile) {
      margin-bottom: 24px;
    }

    img {
      height: 100%;
    }
  }

  &__text {
    color: white;
    max-width: 989px;

    @media (max-width: $large) {
      max-width: 791px;
    }
  }

  &__img {
    position: absolute;
    bottom: 0;
    right: 0;

    @media (max-width: $large) {
      height: 52%;
    }

    @media (max-width: $mobile) {
      display: none;
    }
  }

  &__wrapper {
    position: relative;
    z-index: 1;
  }

  &__btn {
    color: white;
    border: 2px solid white;
    border-radius: 100px;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 8px;
    padding: 24px;
    background-color: transparent;
    display: inline-flex;
    margin-top: 48px;
    @include transition();

    &:hover {
      background-color: white;
      color: var(--dark-color);

      .partners-card__arrow-icon {
        fill: var(--dark-color);
      }
    }

    @media (max-width: $medium) {
      margin-top: 36px;
    }

    @media (max-width: $mobile) {
      margin-top: 24px;
      font-size: 16px;
      padding: 15px 24px;
    }
  }

  &__arrow-icon {
    fill: white;
    margin-left: 10px;
    @include transition();
  }

  &__link {
    display: block;
    flex: 1;
  }
}
</style>
